import { useMutation } from "react-query";
import http from "infra/http";

function useDesvincularAreaComum(tenantId: string, id: string) {
  return useMutation(
    (areaComumVinculadaId: string) => {
      return http.post(
        `/v1/tenants/${tenantId}/area-comum/${id}/desvincular`,
        {areaComumVinculadaId}
      );
    },
    { retry: false }
  );
}

export default useDesvincularAreaComum;
